exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".collapse-item__tip[data-v-8cf39748]{font-style:italic;opacity:.8;display:inline-block;float:right;margin-right:1rem;font-weight:600;color:#f67e22}.collapse-item__tip[data-v-8cf39748]:hover{opacity:1}.drawer .el-collapse-item__header[data-v-8cf39748],.drawer .el-collapse-item__wrap[data-v-8cf39748]{background-color:#fafafa}.new-request__search-cont[data-v-8cf39748]{padding:0 0 30px}.new-request__search[data-v-8cf39748]{width:100%}.buttons-section[data-v-8cf39748]{margin-bottom:20px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8cf39748","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/staff/blocks/NewRequest.vue
// module id = 512
// module chunks = 0